/**
 * Tv Season Row to VOD section
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 30.01.2015-19:42
 */

lmApp.
  directive('lmTvSeasonRow', [function () {
    return {
      restrict: 'E',
      scope: true,
      replace: true,
      link: function (scope, element, attrs, ngModel) {
        scope.season = scope.$eval(attrs.season);
      },
      controller: 'LmSeasonEditController',
      templateUrl: 'lm-table-rows/tv-season-row/tv-season-row.tpl.html'
    };
  }]);

lmApp
  .controller('LmSeasonEditController', ['$scope', '$rootScope', '$timeout', '$q', 'AssetService', 'MetadataService',
    function ($scope, $rootScope, $timeout, $q, AssetService, MetadataService) {

      $scope._STREAM_TYPES_ATTRS = {
        'dash': {
          title: 'DASH',
          placeholder: 'Example: http://transcoder.net/content/playlist.m3u8'
        },
        'hls': {
          title: 'HLS',
          placeholder: 'Example: http://transcoder.net/content/output.mpd'
        },
        'youtube': {
          title: 'Youtube',
          placeholder: 'Example: https://www.youtube.com/user/ChannelName'
        }
      };

      $scope.createSeason = function (parent) {
        parent.newSeason._Parent = {};
        parent.newSeason._Parent.title = parent.title;
        parent.newSeason._Parent.id = parent.id;
        parent.newSeason.isEdit = true;
      };

      $scope.editSeason = function (season, parent) {
        if (season.isEdit) {
          season.isEdit = false;
          return;
        }
        season._Parent.title = parent.title;
        season._Parent.id = parent.id;
        season.isEdit = true;
      };

      $scope.saveSeason = function (season) {
        if (season.isNew) {
          var ext_id = "personal:" + CryptoJS.MD5(season.title + season._Parent.title).toString(CryptoJS.enc.Hex);
          AssetService.CreateNewTVSeason(ext_id, season, {id: season._Parent.id, season_index: season.index})
            .then(function () {
              season.isEdit = false;
              $rootScope.$broadcast($rootScope.EVENTS.UPDATE_VOD_COLLECTION, {id: 'all', timestamp: Date.now()});
            });
        } else {
          AssetService.UpdateTVSeasonMetadata(season, {
            id: season._Parent.id,
            season_id: season.id,
            season_index: season.index
          })
            .then(function () {
              season.isEdit = false;
              $rootScope.$broadcast($rootScope.EVENTS.UPDATE_VOD_COLLECTION, {id: 'all', timestamp: Date.now()});
            });
        }
      };

      $scope.toggleEpisodes = function (season) {
        if (!season.isShowen) {

          var idToGet = season.episodes.filter(function (ep) {
            return typeof ep !== 'object';
          });

          if (season.episodes.length && !idToGet.length) {
            season.isShowen = !season.isShowen;
          } else {
            $rootScope.showLinearProgress('#seasonLoader' + season.id);
            season.episodesQ = !season.episodes.length ? $q.when([]) : AssetService.GetAssetInId(idToGet);
            season.episodesQ
              .then(function (collection) {

                season.episodes = season.episodes.map(function (ep) {
                  if (typeof ep !== 'object') {
                    return _.find(collection, {id: ep});
                  } else {
                    return ep
                  }
                });

                season.episodes = season.episodes.map(function (episode, index) {
                  episode._PrivateData = {};

                  episode.type = $scope.getAssetType(episode);
                  episode._Parent = season._Parent;
                  episode._Parent.currentSeason = season.id;
                  return episode;
                });

                $rootScope.hideLinearProgress('#seasonLoader' + season.id);
                season.isShowen = !season.isShowen;
                delete season.episodesQ;
              }, function (reason) {
                $rootScope.debugInfo(reason);
              });
          }
        } else {
          season.isShowen = !season.isShowen;
        }
      };
    }]);
